const API_URL = "https://api.master.yflow.io/v1/";

export { API_URL };
